import React from 'react';
import {useFormContext} from 'react-hook-form';
import PropTypes from 'prop-types';

const Textarea = ({name, className = 'form-control', ...rest}) => {
  const {register, errors} = useFormContext();

  return (
    <>
      <textarea
        className={`${className} ${errors[name] && 'error-field'}`}
        ref={register}
        name={name}
        {...rest}
      />

      {errors[name] && (
        <span className="error-message">{errors[name].message}</span>
      )}
    </>
  );
};

export default Textarea;

Textarea.propTypes = {
  name: PropTypes.string.isRequired,
};
